import * as React from 'react';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { SortTool } from '../../../common/react/components/SortTool';
import { IReactTranslateService } from '../../../common/react/IReactTranslateService';
import { SorterActions } from '../../../common/react/SorterActions';
import { PlaceName } from '../../../ts/models/IPlace';
import { DataConnectionsGrid } from '../DataConnectionsGrid';
import { DatasourceGrid } from '../DatasourceGrid';
import { ProjectGrid } from '../ProjectGrid';
import { ViewGrid } from '../ViewGrid';
import { WorkbookGrid } from '../WorkbookGrid';

export class ActionBarSortTool extends React.PureComponent<ActionBarSortTool.Props, any> {
  public static displayName = 'ActionBarSortTool';
  public static element = React.createFactory(ActionBarSortTool);

  public render() {
    const sortByLabel = React.createElement('span', {
      className: 'tb-row-height-box',
      style: {
        marginRight: CommonStyles.Sizes.DefaultSpace
      },
    }, this.props.translate('sortBy'));

    const sortToolElement = SortTool.element({
      translate: this.props.translate,
      sorterActions: this.props.sorterActions,
      sortOptions: this.sortOptions(this.props.contentType, this.props.placeName),
      style: {
        width: 200
      }
    });

    return React.createElement('span', {
      style: {
        paddingLeft: CommonStyles.Sizes.DefaultSpace,
        paddingRight: CommonStyles.Sizes.DefaultSpace,
        display: 'inline-block',
      }
    },
      sortByLabel,
      sortToolElement
    );
  }

  private sortOptions(contentType: string, placeName: PlaceName): SortTool.SortOption[] {
    const hasSearchFilter = !!this.props.searchFilter;
    switch (contentType) {
      case 'project':
        return ProjectGrid.sortOptions();
      case 'dataConnection':
        return DataConnectionsGrid.sortOptions(placeName, hasSearchFilter);
      case 'datasource':
        return DatasourceGrid.sortOptions(placeName, hasSearchFilter);
      case 'workbook':
        return WorkbookGrid.sortOptions(placeName, hasSearchFilter);
      case 'view':
        return ViewGrid.sortOptions(placeName, hasSearchFilter);
      default:
        return [];
    }
  }
}

export module ActionBarSortTool {
  export interface Props {
    contentType: string;
    placeName: PlaceName;
    translate: IReactTranslateService;
    sorterActions: SorterActions;
    searchFilter: string;
  }
}
